/* Translation of locales/en-US/packs.ts (generated from lib/industryPacks/catalog.ts). Same keys;
 * only the values are translated. */
export const packs = {
  "property": {
    "assetTypes": {
      "0": "منزل",
      "1": "شقة",
      "2": "مكتب",
      "3": "غلاية",
      "4": "نظام كهربائي",
      "5": "معدات مكافحة الحريق",
      "6": "جهاز"
    },
    "sample": {
      "name": "عقار تجريبي",
      "description": "عقار نموذجي لتجرّب فحصًا قبل إضافة عقاراتك."
    },
    "templates": {
      "condition_inspection": {
        "name": "فحص حالة العقار",
        "description": "تجوّل في العقار وسجّل حالته غرفة بغرفة.",
        "items": {
          "0": {
            "label": "الحالة الخارجية والمحيط"
          },
          "1": {
            "label": "السقف والمزاريب وتصريف مياه الأمطار"
          },
          "2": {
            "label": "النوافذ والأبواب الخارجية"
          },
          "3": {
            "label": "رطوبة أو عفن أو أضرار مياه",
            "description": "أجب بنعم إذا وُجد أي منها."
          },
          "4": {
            "label": "التدفئة والمياه الساخنة تعمل"
          },
          "5": {
            "label": "الحالة الداخلية عمومًا"
          }
        }
      },
      "room_inspection": {
        "name": "فحص غرفة",
        "description": "غرفة واحدة بتفاصيل تكفي لحسم أي خلاف لاحقًا.",
        "groups": {
          "0": {
            "label": "حالة الغرفة",
            "guidance": "صوّر الجدران والسقف والأرضية والنوافذ. وأظهر جهاز إنذار الدخان إن وُجد."
          },
          "1": {
            "label": "الخدمات والتجهيزات"
          }
        },
        "items": {
          "0": {
            "label": "الجدران والسقف"
          },
          "1": {
            "label": "غطاء الأرضية"
          },
          "2": {
            "label": "النافذة والزجاج"
          },
          "3": {
            "label": "جهاز إنذار الدخان موجود"
          },
          "4": {
            "label": "المقابس والمفاتيح والإضاءة"
          },
          "5": {
            "label": "التركيبات والتجهيزات"
          },
          "6": {
            "label": "النظافة"
          }
        }
      },
      "move_in_out": {
        "name": "الاستلام / التسليم",
        "description": "السجل الذي يتفق عليه الطرفان عند التسليم.",
        "items": {
          "0": {
            "label": "قراءات العدادات مسجّلة"
          },
          "1": {
            "label": "المفاتيح مُسلّمة ومعدودة"
          },
          "2": {
            "label": "إنذارات الدخان وأول أكسيد الكربون مُختبرة"
          },
          "3": {
            "label": "النظافة العامة"
          },
          "4": {
            "label": "الأضرار الموجودة مصوّرة"
          },
          "5": {
            "label": "الأجهزة موجودة وتعمل"
          }
        }
      },
      "fire_safety_check": {
        "name": "فحص السلامة من الحريق",
        "description": "الإنذارات والمسارات والمعدات. أدلة، وليست رأيًا قانونيًا.",
        "items": {
          "0": {
            "label": "إنذارات الدخان موجودة وتُصدر صوتًا"
          },
          "1": {
            "label": "إنذار أول أكسيد الكربون موجود ويُصدر صوتًا"
          },
          "2": {
            "label": "مسارات الهروب خالية"
          },
          "3": {
            "label": "أبواب الحريق تُغلق بالكامل"
          },
          "4": {
            "label": "طفايات الحريق سارية الصلاحية"
          },
          "5": {
            "label": "إضاءة الطوارئ تعمل"
          }
        }
      },
      "maintenance_walkthrough": {
        "name": "جولة الصيانة العامة",
        "description": "الجولة الروتينية التي تكتشف المشكلات وهي صغيرة.",
        "items": {
          "0": {
            "label": "السباكة والتسربات الظاهرة"
          },
          "1": {
            "label": "حالة نظام التدفئة"
          },
          "2": {
            "label": "الكهرباء والأسلاك الظاهرة"
          },
          "3": {
            "label": "الأبواب والأقفال والأمان"
          },
          "4": {
            "label": "المحيط والتصريف"
          }
        }
      }
    },
    "maintenance": {
      "boiler_annual_service": {
        "title": "الصيانة السنوية للغلاية",
        "description": "صيانة الغلاية والحفاظ على سجل سلامة الغاز محدّثًا."
      },
      "fire_safety_quarterly": {
        "title": "فحص السلامة من الحريق ربع السنوي",
        "description": "الإنذارات ومسارات الهروب والمعدات."
      }
    },
    "compliance": {
      "gas_safety": {
        "label": "سجل سلامة الغاز"
      },
      "eicr": {
        "label": "تقرير حالة التمديدات الكهربائية (EICR)"
      },
      "fire_safety": {
        "label": "أدلة السلامة من الحريق، بما فيها إنذارات الدخان وأول أكسيد الكربون"
      }
    }
  },
  "fleet": {
    "assetTypes": {
      "0": "سيارة",
      "1": "فان",
      "2": "شاحنة",
      "3": "مقطورة"
    },
    "sample": {
      "name": "فان تجريبي",
      "description": "مركبة نموذجية لتجرّب فحصًا يوميًا قبل إضافة مركباتك."
    },
    "templates": {
      "daily_vehicle_check": {
        "name": "الفحص اليومي للمركبة",
        "description": "جولة الفحص قبل أن تتحرك المركبة.",
        "items": {
          "0": {
            "label": "الأضواء والإشارات"
          },
          "1": {
            "label": "الإطارات وضغطها"
          },
          "2": {
            "label": "المكابح تعمل بشكل طبيعي"
          },
          "3": {
            "label": "المرايا والزجاج"
          },
          "4": {
            "label": "مستويات السوائل"
          },
          "5": {
            "label": "أضواء التحذير في لوحة العدادات",
            "description": "أجب بنعم إذا كان أي منها مضاءً."
          },
          "6": {
            "label": "الحمولة مثبتة"
          }
        }
      },
      "vehicle_condition": {
        "name": "حالة المركبة",
        "description": "سجل الحالة الأشمل، من الهيكل إلى المقصورة.",
        "groups": {
          "0": {
            "label": "الخارج",
            "guidance": "تجوّل حول المركبة. صوّر كل جانب، والأضواء، والزجاج، والإطارات."
          },
          "1": {
            "label": "الداخل",
            "guidance": "صوّر المقاعد ولوحة العدادات وعداد المسافة."
          },
          "2": {
            "label": "السجلات"
          }
        },
        "items": {
          "0": {
            "label": "حالة الهيكل"
          },
          "1": {
            "label": "عمق نقشة الإطارات مقبول"
          },
          "2": {
            "label": "الزجاج والمرايا"
          },
          "3": {
            "label": "الأضواء سليمة"
          },
          "4": {
            "label": "حالة المقصورة"
          },
          "5": {
            "label": "قراءة عداد المسافة"
          },
          "6": {
            "label": "سجل الصيانة محدّث"
          }
        }
      },
      "damage_inspection": {
        "name": "فحص الأضرار",
        "description": "ماذا حدث، وأين، وكيف يبدو.",
        "items": {
          "0": {
            "label": "الضرر مصوّر من جميع الجوانب"
          },
          "1": {
            "label": "المركبة لا تزال صالحة للسير"
          },
          "2": {
            "label": "الألواح والهيكل"
          },
          "3": {
            "label": "الزجاج والأضواء سليمة"
          },
          "4": {
            "label": "طرف ثالث متورط"
          }
        }
      },
      "handover": {
        "name": "تسليم المركبة",
        "description": "الحالة والمحتويات لحظة انتقال المفاتيح من شخص إلى آخر.",
        "items": {
          "0": {
            "label": "قراءة عداد المسافة مسجّلة"
          },
          "1": {
            "label": "مستوى الوقود أو الشحن مسجّل"
          },
          "2": {
            "label": "المفاتيح والمستندات مُسلّمة"
          },
          "3": {
            "label": "الأضرار الموجودة مسجّلة"
          },
          "4": {
            "label": "النظافة"
          }
        }
      },
      "tyres": {
        "name": "فحص الإطارات",
        "description": "النقشة والضغط والحالة، إطارًا بإطار.",
        "items": {
          "0": {
            "label": "الأمامي الأيسر"
          },
          "1": {
            "label": "الأمامي الأيمن"
          },
          "2": {
            "label": "الخلفي الأيسر"
          },
          "3": {
            "label": "الخلفي الأيمن"
          },
          "4": {
            "label": "الإطار الاحتياطي أو عدة الإصلاح موجودة"
          }
        }
      },
      "service_check": {
        "name": "فحص الصيانة الدورية",
        "description": "ما فحصته الورشة وما وجدته.",
        "items": {
          "0": {
            "label": "قراءة عداد المسافة مسجّلة"
          },
          "1": {
            "label": "تم تغيير الزيت والفلتر"
          },
          "2": {
            "label": "تم فحص المكابح"
          },
          "3": {
            "label": "نظام التعليق والتوجيه"
          },
          "4": {
            "label": "تمت قراءة رموز الأعطال ومسحها"
          }
        }
      }
    },
    "maintenance": {
      "service_whichever_first": {
        "title": "الصيانة: 12 شهرًا أو 10,000 ميل",
        "description": "أيهما يحل أولًا، محسوبًا من آخر صيانة مكتملة."
      },
      "service_calendar": {
        "title": "الصيانة السنوية",
        "description": "كل 12 شهرًا من آخر صيانة مكتملة."
      },
      "service_mileage": {
        "title": "صيانة كل 10,000 ميل",
        "description": "حسب المسافة فقط، محسوبة من القراءة عند آخر صيانة."
      }
    },
    "compliance": {
      "roadworthy": {
        "label": "اختبار صلاحية المركبة للسير، مثل الفحص الفني الدوري (MOT)"
      },
      "insurance": {
        "label": "تأمين المركبة"
      }
    }
  },
  "equipment": {
    "assetTypes": {
      "0": "آلة",
      "1": "أداة",
      "2": "معدات الرفع",
      "3": "رافعة شوكية",
      "4": "ضاغط"
    },
    "sample": {
      "name": "آلة تجريبية",
      "description": "آلة نموذجية لتجرّب فحص ما قبل الاستخدام قبل إضافة آلاتك."
    },
    "templates": {
      "pre_use_check": {
        "name": "فحص ما قبل الاستخدام",
        "description": "الفحص الذي يسبق بدء المشغّل العمل.",
        "items": {
          "0": {
            "label": "الواقيات وأجهزة السلامة في مكانها"
          },
          "1": {
            "label": "زر إيقاف الطوارئ يعمل"
          },
          "2": {
            "label": "لا أضرار أو تسربات ظاهرة"
          },
          "3": {
            "label": "أدوات التحكم والمؤشرات تعمل"
          },
          "4": {
            "label": "ساعات التشغيل مسجّلة"
          }
        }
      },
      "condition_inspection": {
        "name": "فحص الحالة",
        "description": "مدى تحمّل الآلة للاستخدام.",
        "groups": {
          "0": {
            "label": "التعريف",
            "guidance": "صوّر لوحة التعريف وملصق الأصل."
          },
          "1": {
            "label": "الحالة الخارجية",
            "guidance": "صوّر الجهة الأمامية والجانبين وقاعدة المعدة. وضمّن الواقيات والخراطيم والوصلات."
          },
          "2": {
            "label": "بيانات التشغيل",
            "guidance": "صوّر عداد الساعات."
          },
          "3": {
            "label": "الفحص الوظيفي"
          }
        },
        "items": {
          "0": {
            "label": "الرقم التسلسلي"
          },
          "1": {
            "label": "الحالة العامة"
          },
          "2": {
            "label": "تسرب ظاهر"
          },
          "3": {
            "label": "الواقيات موجودة ومثبتة"
          },
          "4": {
            "label": "الكابلات والموصلات الكهربائية"
          },
          "5": {
            "label": "الأنظمة الهيدروليكية والهوائية"
          },
          "6": {
            "label": "الملصقات والعلامات مقروءة"
          },
          "7": {
            "label": "ساعات التشغيل"
          },
          "8": {
            "label": "تآكل الأجزاء المتحركة"
          },
          "9": {
            "label": "تبدأ وتعمل بشكل صحيح"
          },
          "10": {
            "label": "لا ضجيج أو اهتزاز غير معتاد"
          }
        }
      },
      "maintenance_inspection": {
        "name": "فحص الصيانة",
        "description": "زيارة الصيانة المخططة وما وجدته.",
        "items": {
          "0": {
            "label": "ساعات التشغيل أو الدورات مسجّلة"
          },
          "1": {
            "label": "تم التشحيم"
          },
          "2": {
            "label": "تم استبدال الفلاتر والمواد الاستهلاكية"
          },
          "3": {
            "label": "أُعيد اختبار أجهزة السلامة"
          },
          "4": {
            "label": "أُعيدت إلى الخدمة"
          }
        }
      },
      "calibration_evidence": {
        "name": "فحص أدلة المعايرة",
        "description": "هل المعايرة المسجّلة سارية وقابلة للتتبع.",
        "items": {
          "0": {
            "label": "شهادة المعايرة محفوظة"
          },
          "1": {
            "label": "المعايرة لا تزال سارية"
          },
          "2": {
            "label": "ملصق المعايرة على المعدة"
          },
          "3": {
            "label": "المعيار المرجعي قابل للتتبع"
          }
        }
      }
    },
    "maintenance": {
      "service_operating_hours": {
        "title": "صيانة كل 500 ساعة تشغيل",
        "description": "محسوبة من قراءة الساعات عند آخر صيانة مكتملة.",
        "programmeTitle": "برنامج ساعات التشغيل"
      },
      "service_operating_hours_major": {
        "title": "صيانة كبرى كل 1,000 ساعة تشغيل",
        "description": "الصيانة الأعمق، محسوبة على عداد الساعات نفسه."
      },
      "service_cycles": {
        "title": "إصلاح شامل كل 2,000 دورة",
        "description": "محسوب من عدد الدورات عند آخر إصلاح شامل مكتمل."
      }
    },
    "compliance": {
      "lifting": {
        "label": "الفحص الشامل لمعدات الرفع"
      },
      "electrical": {
        "label": "أدلة السلامة الكهربائية، مثل سجل فحص الأجهزة المحمولة (PAT)"
      }
    }
  },
  "facilities": {
    "assetTypes": {
      "0": "مبنى",
      "1": "التدفئة والتهوية والتكييف",
      "2": "مضخة",
      "3": "مولد",
      "4": "نظام الحريق",
      "5": "توزيع الكهرباء"
    },
    "sample": {
      "name": "مبنى تجريبي",
      "description": "مبنى نموذجي لتجرّب فحصًا قبل إضافة مبانيك."
    },
    "templates": {
      "planned_maintenance": {
        "name": "الصيانة المخططة",
        "description": "الزيارة المجدولة لإحدى معدات المنشأة.",
        "items": {
          "0": {
            "label": "ساعات التشغيل مسجّلة"
          },
          "1": {
            "label": "الفلاتر والسيور"
          },
          "2": {
            "label": "تسربات أو ضجيج أو اهتزاز"
          },
          "3": {
            "label": "أدوات التحكم ونقاط الضبط صحيحة"
          },
          "4": {
            "label": "أجهزة العزل والسلامة مُختبرة"
          }
        }
      },
      "condition_inspection": {
        "name": "فحص الحالة",
        "description": "مدى تحمّل المبنى ومعداته للاستخدام.",
        "items": {
          "0": {
            "label": "هيكل المبنى"
          },
          "1": {
            "label": "السقف والتصريف"
          },
          "2": {
            "label": "المعدات الميكانيكية"
          },
          "3": {
            "label": "توزيع الكهرباء"
          },
          "4": {
            "label": "المناطق المشتركة"
          }
        }
      },
      "safety_inspection": {
        "name": "فحص السلامة",
        "description": "الأمور التي يجب أن تكون سليمة قبل وجود أي شخص في المبنى.",
        "items": {
          "0": {
            "label": "لوحة إنذار الحريق بلا أعطال"
          },
          "1": {
            "label": "مسارات الهروب والمخارج النهائية خالية"
          },
          "2": {
            "label": "إضاءة الطوارئ تعمل"
          },
          "3": {
            "label": "طفايات الحريق سارية الصلاحية وفي أماكنها"
          },
          "4": {
            "label": "اللافتات موجودة ومقروءة"
          }
        }
      },
      "plant_room_check": {
        "name": "فحص غرفة المعدات",
        "description": "الجولة الروتينية في غرفة المعدات.",
        "items": {
          "0": {
            "label": "غرفة المعدات مؤمّنة وخالية من العوائق"
          },
          "1": {
            "label": "لا تسربات أو مياه راكدة"
          },
          "2": {
            "label": "الضغوط ودرجات الحرارة ضمن النطاق"
          },
          "3": {
            "label": "الإنذارات والمؤشرات طبيعية"
          },
          "4": {
            "label": "التهوية غير معاقة"
          }
        }
      },
      "energy_walkround": {
        "name": "جولة الطاقة والبيئة",
        "description": "جولة في المبنى للبحث عن هدر الطاقة والمياه، والتحقق من قراءة العدادات.",
        "items": {
          "0": {
            "label": "قُرئت العدادات هذا الشهر"
          },
          "1": {
            "label": "الأضواء مطفأة في المناطق الفارغة"
          },
          "2": {
            "label": "التدفئة والتبريد مضبوطان على درجات الحرارة المتفق عليها"
          },
          "3": {
            "label": "التدفئة والتبريد لا يعملان معًا"
          },
          "4": {
            "label": "الأبواب والنوافذ مغلقة حيث تعمل التدفئة أو التبريد"
          },
          "5": {
            "label": "لا صنابير تقطر ولا مراحيض يتسرب منها الماء"
          },
          "6": {
            "label": "الأجهزة مطفأة خارج ساعات العمل"
          },
          "7": {
            "label": "شهادة الطاقة معروضة حيث يلزم"
          }
        }
      },
      "fgas_leak_check": {
        "name": "فحص تسرّب الغازات المفلورة",
        "description": "الفحص الدوري للتسرّب في نظام يحتوي غاز تبريد مفلورًا، يجريه فني معتمد.",
        "items": {
          "0": {
            "label": "الفني معتمد للغازات المفلورة"
          },
          "1": {
            "label": "فُحصت الوصلات والصمامات والحشوات"
          },
          "2": {
            "label": "نظام كشف التسرّب يعمل (إن وُجد)"
          },
          "3": {
            "label": "لا آثار زيت حول الوصلات"
          },
          "4": {
            "label": "أُضيف غاز تبريد (سجّل الكمية بالكيلوغرام على الأصل)"
          },
          "5": {
            "label": "وُجد تسرّب"
          },
          "6": {
            "label": "لوحة الجهاز تبيّن نوع غاز التبريد وكميته"
          }
        }
      }
    },
    "maintenance": {
      "ppm_quarterly": {
        "title": "الصيانة المخططة ربع السنوية",
        "description": "كل 3 أشهر من آخر زيارة مكتملة."
      },
      "generator_hours": {
        "title": "صيانة المولد كل 250 ساعة تشغيل",
        "description": "محسوبة من قراءة الساعات عند آخر صيانة مكتملة."
      }
    },
    "compliance": {
      "energy_performance": {
        "label": "شهادة أداء الطاقة (EPC)"
      },
      "water_hygiene": {
        "label": "أدلة سلامة المياه، مثل تقييم مخاطر الليجيونيلا"
      },
      "fire_safety": {
        "label": "أدلة السلامة من الحريق"
      },
      "lifting": {
        "label": "الفحص الشامل لمعدات الرفع"
      },
      "electrical": {
        "label": "تقرير حالة التمديدات الكهربائية (EICR)"
      }
    }
  }
};
